<template>

  <div>

    <div v-bind:id="modalId" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="popup-label">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="modal-title"/>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <slot name="modal-body"/>
          </div>
          <div class="modal-footer">
            <slot name="modal-footer"/>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

  </div>

</template>

<script>
export default {
  name: "TemplateModal",
  props: ['modalId'],
};
</script>


// WEBPACK FOOTER //
// src/components/Template/TemplateModal.vue